export default "__VITE_ASSET__DVkTBCof__"